import { render, staticRenderFns } from "./editPatientStories.vue?vue&type=template&id=10e07b88"
import script from "./editPatientStories.vue?vue&type=script&lang=js"
export * from "./editPatientStories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports